// src/components/KnowledgeBaseDetails.js

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Button } from 'antd';
import FilesTab from '../components/KBFilesTab';
import SitesTab from '../components/KBSitesTab';

const KnowledgeBaseDetails = () => {
  const { kbId } = useParams();
  const navigate = useNavigate();

  return (
    <div style={{ padding: '10px' }}>
      <Button onClick={() => navigate(-1)}>Back</Button>
      <Tabs defaultActiveKey="files">
        <Tabs.TabPane tab="Files" key="files">
          <FilesTab knowledgeBaseId={kbId} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Sites" key="sites">
          <SitesTab knowledgeBaseId={kbId} />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default KnowledgeBaseDetails;
